"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgEmojiHappy = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("g", { fill: "#fff", fillRule: "evenodd", clipPath: "url(#emoji-happy_svg__a)", clipRule: "evenodd" },
        React.createElement("path", { fillOpacity: 0.48, d: "M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16" }),
        React.createElement("path", { d: "M7.487 19.104a1 1 0 0 1 1.34.452 8.002 8.002 0 0 0 14.34 0 1 1 0 0 1 1.793.888 10.003 10.003 0 0 1-17.925 0 1 1 0 0 1 .452-1.34M9.454 8.6a5.92 5.92 0 0 1 3.745-.468 1 1 0 0 1-.398 1.96 3.92 3.92 0 0 0-4.268 2.054 1 1 0 1 1-1.78-.911 5.92 5.92 0 0 1 2.7-2.636M21.679 10.401a3.92 3.92 0 0 0-2.48-.309 1 1 0 0 1-.398-1.96 5.92 5.92 0 0 1 6.446 3.103 1 1 0 0 1-1.78.911 3.9 3.9 0 0 0-1.788-1.745" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "emoji-happy_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h32v32H0z" })))));
exports.default = SvgEmojiHappy;
